import type { StoreOrderRow } from '@dukanti/shared';

const MS_IN_24_HOURS = 24 * 60 * 60 * 1000;

/** Returns true if an incoming ordered order was created more than 24 hours ago. */
export function isUrgentOrder(row: Readonly<StoreOrderRow>): boolean {
  if (row.status !== 'ordered') return false;
  const created = new Date(row.created_at).getTime();
  const now = Date.now();
  return now - created > MS_IN_24_HOURS;
}
